import { memo } from "react";
import { getAdaptationUserTable } from "src/Requests/collateral";
import { CommonTableUI } from "src/Tables/TableTemplate/common";
import TableTemplate from "src/Tables/TableTemplate/tableTemplate";

interface IProps {
  refreshFlag: boolean;
  setSelectedAccountIds: (selectedRowsIds: number[]) => void;
  accountIds: number[];
}

const Table = memo(
  ({ accountIds, refreshFlag, setSelectedAccountIds }: IProps) => {
    return (
      <TableTemplate
        TableUI={({ reports, onAction }) => (
          <CommonTableUI
            reports={reports}
            refreshFlag={refreshFlag}
            onAction={onAction}
            withSelect
            onSelectedRowsChange={(selectedRowsIds) => {
              setSelectedAccountIds(selectedRowsIds);
            }}
          />
        )}
        getDataTable={getAdaptationUserTable}
        searchParameters={{
          accountIds: accountIds.length ? accountIds : null,
        }}
      />
    );
  },
);

export default Table;
